import { render, staticRenderFns } from "./mgrClassList.vue?vue&type=template&id=23428e18&scoped=true&"
import script from "./mgrClassList.vue?vue&type=script&lang=js&"
export * from "./mgrClassList.vue?vue&type=script&lang=js&"
import style0 from "./mgrClassList.vue?vue&type=style&index=0&id=23428e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23428e18",
  null
  
)

export default component.exports